<template>
    <div v-if="hasAccessDelete(FUNCTIONALITY)">
        <loader :loading="true" v-if="loading"></loader>
        <h2>Create new forecast window</h2>
        <ForecastForm
            v-if="forecast"
            :forecast="forecast"
            :brand-with-campaigns="brandWithCampaigns"
            :ref-date-is-equal-to-availability-date="refDateIsEqualToAvailabilityDate"
            @update="onUpdate"
        />
        <section class="buttons">
            <ClientColorButton :disabled="!isValid" class="button" @click="createForecast">Save Forecast</ClientColorButton>&nbsp;
            <ClientColorButton @click="$router.push(`${ROUTES.BASE}`)">Cancel</ClientColorButton>
        </section>
        <br />
    </div>
</template>
<script>
import { FORECAST_STATUS, FUNCTIONALITY, RECURRENCE_TYPE, recurrenceTypeLabel } from "@/components/forecasts/constants";
import ClientColorButton from "@/components/ui/ClientColorButton";
import TextInputBloc from "@/components/ui/Form/TextInputBloc";
import FormSectionTitle from "@/components/ui/Form/FormSectionTitle";
import SelectBloc from "@/components/ui/Form/SelectBloc";
import CheckboxGroupBloc from "@/components/ui/Form/CheckboxGroupBloc";
import ForecastForm from "@/components/forecasts/elements/ForecastForm";
import { mapActions } from "vuex";
import TryLoad from "@/mixins/TryLoadMixin";
import loader from "@/components/loader/loader";
import { ROUTES } from "@/components/forecasts/router";
import cacheService from "@/services/cache";
import { OBJECT_TYPE, SHORT_DESCRIPTION } from "@/components/history/constants";
import historyService from "@/services/history";
import brandApplicationHasParametersService from "@/services/brandApplicationHasParameters";
import { APPLICATION, APPLICATION_PARAMETER } from "@/components/admin/brand/constant";

export default {
    components: {
        ForecastForm,
        ClientColorButton,
        TextInputBloc,
        FormSectionTitle,
        SelectBloc,
        CheckboxGroupBloc,
        loader
    },
    mixins: [TryLoad],
    data() {
        return {
            forecast: null,
            RECURRENCE_TYPE,
            FUNCTIONALITY,
            recurrenceTypeLabel,
            isValid: false,
            ROUTES,
            currentBrand: null,
            currentZone: null,
            brandWithCampaigns: null,
            refDateIsEqualToAvailabilityDate: null
        };
    },
    async created() {
        this.currentZone = cacheService.getCurrentZoneId();
        this.currentBrand = cacheService.getCurrentBrandId();
        // Recup du param brand_with_campaigns
        await brandApplicationHasParametersService
            .findByBrandAndApplicationAndParameter(APPLICATION.FORECAST_ID, APPLICATION_PARAMETER.BRAND_WITH_CAMPAIGN)
            .then(res => {
                this.brandWithCampaigns = !!(res && res.value === "1");
            });

        // Recup du param ref date = availability date
        await brandApplicationHasParametersService
            .findByBrandAndApplicationAndParameter(APPLICATION.FORECAST_ID, APPLICATION_PARAMETER.REFDT_EQ_AVAILDT)
            .then(res => {
                this.refDateIsEqualToAvailabilityDate = !!(res && res.value === "1");
            });

        this.initNewForecast();
    },
    methods: {
        // front/src/store/forecast/forecast.js : createForecast
        ...mapActions("forecast", { createForecastInStore: "createForecast" }),
        initNewForecast() {
            this.forecast = {
                name: "",
                reference: "",
                zones: [],
                comments: "",
                items: [],
                status: FORECAST_STATUS.DRAFT,
                campaign: null,
                startDate: null,
                endDate: null,
                refDate: null,
                recurrenceAmount: undefined,
                recurrenceType: RECURRENCE_TYPE.MONTHS,
                // Evo 2023
                launchDate: null,
                availabilityDate: null,
                endOfCampaign: null,
                preseriesDate: null
            };
        },
        onUpdate(data) {
            this.isValid = data.isValid;
            if (this.isValid) {
                this.forecast = data.forecast;
            }
        },
        async createForecast() {
            if (this.currentBrand !== cacheService.getCurrentBrandId() || this.currentZone !== cacheService.getCurrentZoneId()) {
                //TODO Solution d'appoint
                let error = "Warning, a Zone or Brand conflict has been detected. This might be due to a tab opened with a different brand or Zone";
                this.$swal({
                    type: "error",
                    title: "Oops !",
                    text: error
                });
                return;
            }
            let newF = { ...this.forecast };
            try {
                this.tryLoad(() => this.createForecastInStore(newF))
                    .then(newForecast => {
                        this.initNewForecast();
                        this.$router.push(`${ROUTES.BASE}/${newForecast.id}`);
                    })
                    .catch(() => {
                        this.$swal({
                            text: "ERROR TO CREATE FORECAST",
                            type: "error",
                            confirmButtonText: "OK",
                            confirmButtonColor: "#41b4e8",
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        });
                    });
            } catch (e) {
                console.error(e);
                window.alert(e);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
h2 {
    font-family: "Oswald", Sans-Serif;
    font-size: 35px;
    padding: 10px;
}
.buttons {
    margin: 10px;
    display: flex;
    .button {
        margin-left: auto;
    }
}
</style>



// WEBPACK FOOTER //
// ForecastCreate.vue?54b1129a